import { syntaxTree } from "@codemirror/language";

export const wrappedNodeOfType = (state, range, type) => {
    if (range.empty) {
        return null;
    }

    const ancestorNode = ancestorNodeOfType(state, range.from, type, 1);
    if (ancestorNode && ancestorNode.from === range.from && ancestorNode.to === range.to) {
        return ancestorNode;
    }

    return null;
};

export const ancestorNodeOfType = (state, pos, type, side = 0) => {
    const node = syntaxTree(state).resolveInner(pos, side);
    return ancestorOfNodeWithType(node, type);
};

export function* ancestorsOfNodeWithType(node, type) {
    for (let ancestor = node; ancestor; ancestor = ancestor.parent) {
        if (ancestor.type.is(type)) {
            yield ancestor;
        }
    }
}

export const ancestorOfNodeWithType = (node, ...types) => {
    for (let ancestor = node; ancestor; ancestor = ancestor.parent) {
        for (const type of types) {
            if (ancestor.type.is(type)) {
                return ancestor;
            }
        }
    }
    return null;
};

export const lastAncestorAtEndPosition = (node, to) => {
    let lastAncestor = null;
    for (let ancestor = node; ancestor && ancestor.to === to; ancestor = ancestor.parent) {
        lastAncestor = ancestor;
    }
    return lastAncestor;
};

export const matchingAncestor = (node, predicate) => {
    for (let ancestor = node; ancestor; ancestor = ancestor.parent) {
        if (predicate(ancestor)) {
            return ancestor;
        }
    }
    return null;
};

export const commonAncestor = (nodeA, nodeB) => {
    let cursorA = nodeA;
    let cursorB = nodeB;
    while (cursorA && cursorB) {
        if (cursorA === cursorB) {
            return cursorA;
        }
        if (cursorA.from < cursorB.from) {
            cursorB = cursorB.parent;
        } else {
            cursorA = cursorA.parent;
        }
    }
    return null;
};

export const descendantsOfNodeWithType = (node, type, leaveType) => {
    const children = [];
    node.cursor().iterate((nodeRef) => {
        if (nodeRef.type.is(type)) {
            children.push(nodeRef.node);
        }
        if (leaveType && nodeRef.type.is(leaveType) && nodeRef.node !== node) {
            return false;
        }
        return undefined;
    });
    return children;
};

export function* ancestorsOfSelectionWithType(tree, selection, type) {
    for (const range of selection.ranges) {
        const node = tree.resolveInner(range.anchor);
        for (const ancestor of ancestorsOfNodeWithType(node, type)) {
            if (ancestor) {
                yield ancestor;
            }
        }
    }
}

export const ancestorWithType = (state, nodeType) => {
    const tree = syntaxTree(state);
    const ancestors = ancestorsOfSelectionWithType(tree, state.selection, nodeType);
    return ancestors.next().value ?? null;
};

export const listDepthForNode = (node) => {
    let depth = 0;
    for (const ancestor of ancestorsOfNodeWithType(node, "ListEnvironment")) {
        if (ancestor) {
            depth += 1;
        }
    }
    return depth;
};

export const minimumListDepthForSelection = (state) => {
    const tree = syntaxTree(state);
    const depths = state.selection.ranges.map((range) => listDepthForNode(tree.resolveInner(range.anchor)));
    return Math.min(...depths);
};

export const isDirectChildOfEnvironment = (child, ancestor) => {
    const possiblyAncestor = child?.parent?.parent?.parent;
    return ancestor === possiblyAncestor;
};
